module.exports = __webpack_public_path__ + "static/media/african-school-banner.692159a6.png";